module.exports = __webpack_public_path__ + "static/media/camper_bij_de_bergen.646cf14c.jpg";